var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchFindZoomInActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83333 5.20833C9.17851 5.20833 9.45833 5.48816 9.45833 5.83333V7.70833H11.3333C11.6785 7.70833 11.9583 7.98816 11.9583 8.33333C11.9583 8.67851 11.6785 8.95833 11.3333 8.95833H9.45833V10.8333C9.45833 11.1785 9.17851 11.4583 8.83333 11.4583C8.48816 11.4583 8.20833 11.1785 8.20833 10.8333V8.95833H6.33333C5.98816 8.95833 5.70833 8.67851 5.70833 8.33333C5.70833 7.98816 5.98816 7.70833 6.33333 7.70833H8.20833V5.83333C8.20833 5.48816 8.48816 5.20833 8.83333 5.20833Z",
    fill: "#21A6AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4926 12.8765C11.4919 13.6835 10.219 14.1667 8.83333 14.1667C5.61167 14.1667 3 11.555 3 8.33333C3 5.11167 5.61167 2.5 8.83333 2.5C12.055 2.5 14.6667 5.11167 14.6667 8.33333C14.6667 9.71902 14.1835 10.9919 13.3765 11.9926L17.6086 16.2247C17.8527 16.4688 17.8527 16.8645 17.6086 17.1086C17.3645 17.3527 16.9688 17.3527 16.7247 17.1086L12.4926 12.8765ZM13.4167 8.33333C13.4167 10.8646 11.3646 12.9167 8.83333 12.9167C6.30203 12.9167 4.25 10.8646 4.25 8.33333C4.25 5.80203 6.30203 3.75 8.83333 3.75C11.3646 3.75 13.4167 5.80203 13.4167 8.33333Z",
    fill: "#21A6AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchFindZoomInActive);
export default __webpack_public_path__ + "static/media/search-find-zoom-in-active.483c19d89c4fb278d9977fcc487e5dcd.svg";
export { ForwardRef as ReactComponent };